module.exports = __webpack_public_path__ + "static/beccah-0798b6b76948a416944dc6c3cfb380a4.jpg";